const DRAWER_WIDTH = 480;
const constants = { DRAWER_WIDTH };

export default constants;
